import { authFetch } from './api';
const API = process.env.REACT_APP_API_BASE_URL;
export async function prepareWixBrand(botId, signal) {
  const controller = new AbortController();
  const abort = () => controller.abort();
  const timer = setTimeout(abort, 45000);
  signal?.addEventListener('abort', abort, { once: true });
  try {
    while (!controller.signal.aborted && !signal?.aborted) {
      const response = await authFetch(`${API}wix/onboarding/prepare_brand?bot_id=${encodeURIComponent(botId)}`, {
        method: 'POST', signal: controller.signal,
      });
      if (!response?.ok) throw new Error('brand preparation failed');
      const value = await response.json();
      if (value.status !== 'pending') return value;
      await new Promise(resolve => setTimeout(resolve, 800));
    }
    return { status: 'timeout' };
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', abort);
  }
}
